// Sample data for HELLO / BONJOUR in all directions on a 12×12 grid (centered; indices 0–11)

export const helloWordDirections = [
    {
        id: "horizontal-right-1",
        direction: "horizontal-right",
        text: "HELLO",
        length: 5,
        positions: [
            { row: 5, col: 3, value: "H" },
            { row: 5, col: 4, value: "E" },
            { row: 5, col: 5, value: "L" },
            { row: 5, col: 6, value: "L" },
            { row: 5, col: 7, value: "O" }
        ],
        reversed: false
    },
    {
        id: "horizontal-left-1",
        direction: "horizontal-left",
        text: "HELLO",
        length: 5,
        positions: [
            { row: 5, col: 7, value: "H" },
            { row: 5, col: 6, value: "E" },
            { row: 5, col: 5, value: "L" },
            { row: 5, col: 4, value: "L" },
            { row: 5, col: 3, value: "O" }
        ],
        reversed: true
    },
    {
        id: "vertical-down-1",
        direction: "vertical-down",
        text: "HELLO",
        length: 5,
        positions: [
            { row: 3, col: 5, value: "H" },
            { row: 4, col: 5, value: "E" },
            { row: 5, col: 5, value: "L" },
            { row: 6, col: 5, value: "L" },
            { row: 7, col: 5, value: "O" }
        ],
        reversed: false
    },
    {
        id: "vertical-up-1",
        direction: "vertical-up",
        text: "HELLO",
        length: 5,
        positions: [
            { row: 7, col: 5, value: "H" },
            { row: 6, col: 5, value: "E" },
            { row: 5, col: 5, value: "L" },
            { row: 4, col: 5, value: "L" },
            { row: 3, col: 5, value: "O" }
        ],
        reversed: true
    },
    {
        id: "diagonal-right-down-1",
        direction: "diagonal-right-down",
        text: "HELLO",
        length: 5,
        positions: [
            { row: 3, col: 3, value: "H" },
            { row: 4, col: 4, value: "E" },
            { row: 5, col: 5, value: "L" },
            { row: 6, col: 6, value: "L" },
            { row: 7, col: 7, value: "O" }
        ],
        reversed: false
    },
    {
        id: "diagonal-right-up-1",
        direction: "diagonal-right-up",
        text: "HELLO",
        length: 5,
        positions: [
            { row: 7, col: 3, value: "H" },
            { row: 6, col: 4, value: "E" },
            { row: 5, col: 5, value: "L" },
            { row: 4, col: 6, value: "L" },
            { row: 3, col: 7, value: "O" }
        ],
        reversed: true
    },
    {
        id: "diagonal-left-down-1",
        direction: "diagonal-left-down",
        text: "HELLO",
        length: 5,
        positions: [
            { row: 3, col: 7, value: "H" },
            { row: 4, col: 6, value: "E" },
            { row: 5, col: 5, value: "L" },
            { row: 6, col: 4, value: "L" },
            { row: 7, col: 3, value: "O" }
        ],
        reversed: false
    },
    {
        id: "diagonal-left-up-1",
        direction: "diagonal-left-up",
        text: "HELLO",
        length: 5,
        positions: [
            { row: 7, col: 7, value: "H" },
            { row: 6, col: 6, value: "E" },
            { row: 5, col: 5, value: "L" },
            { row: 4, col: 4, value: "L" },
            { row: 3, col: 3, value: "O" }
        ],
        reversed: true
    }
];

export const bonjourWordDirections = [
    { id: "horizontal-right-1", direction: "horizontal-right", text: "BONJOUR", length: 7, positions: [{ row: 5, col: 2, value: "B" }, { row: 5, col: 3, value: "O" }, { row: 5, col: 4, value: "N" }, { row: 5, col: 5, value: "J" }, { row: 5, col: 6, value: "O" }, { row: 5, col: 7, value: "U" }, { row: 5, col: 8, value: "R" }], reversed: false },
    { id: "horizontal-left-1", direction: "horizontal-left", text: "BONJOUR", length: 7, positions: [{ row: 5, col: 8, value: "B" }, { row: 5, col: 7, value: "O" }, { row: 5, col: 6, value: "N" }, { row: 5, col: 5, value: "J" }, { row: 5, col: 4, value: "O" }, { row: 5, col: 3, value: "U" }, { row: 5, col: 2, value: "R" }], reversed: true },
    { id: "vertical-down-1", direction: "vertical-down", text: "BONJOUR", length: 7, positions: [{ row: 2, col: 5, value: "B" }, { row: 3, col: 5, value: "O" }, { row: 4, col: 5, value: "N" }, { row: 5, col: 5, value: "J" }, { row: 6, col: 5, value: "O" }, { row: 7, col: 5, value: "U" }, { row: 8, col: 5, value: "R" }], reversed: false },
    { id: "vertical-up-1", direction: "vertical-up", text: "BONJOUR", length: 7, positions: [{ row: 8, col: 5, value: "B" }, { row: 7, col: 5, value: "O" }, { row: 6, col: 5, value: "N" }, { row: 5, col: 5, value: "J" }, { row: 4, col: 5, value: "O" }, { row: 3, col: 5, value: "U" }, { row: 2, col: 5, value: "R" }], reversed: true },
    { id: "diagonal-right-down-1", direction: "diagonal-right-down", text: "BONJOUR", length: 7, positions: [{ row: 2, col: 2, value: "B" }, { row: 3, col: 3, value: "O" }, { row: 4, col: 4, value: "N" }, { row: 5, col: 5, value: "J" }, { row: 6, col: 6, value: "O" }, { row: 7, col: 7, value: "U" }, { row: 8, col: 8, value: "R" }], reversed: false },
    { id: "diagonal-right-up-1", direction: "diagonal-right-up", text: "BONJOUR", length: 7, positions: [{ row: 8, col: 2, value: "B" }, { row: 7, col: 3, value: "O" }, { row: 6, col: 4, value: "N" }, { row: 5, col: 5, value: "J" }, { row: 4, col: 6, value: "O" }, { row: 3, col: 7, value: "U" }, { row: 2, col: 8, value: "R" }], reversed: true },
    { id: "diagonal-left-down-1", direction: "diagonal-left-down", text: "BONJOUR", length: 7, positions: [{ row: 2, col: 8, value: "B" }, { row: 3, col: 7, value: "O" }, { row: 4, col: 6, value: "N" }, { row: 5, col: 5, value: "J" }, { row: 6, col: 4, value: "O" }, { row: 7, col: 3, value: "U" }, { row: 8, col: 2, value: "R" }], reversed: false },
    { id: "diagonal-left-up-1", direction: "diagonal-left-up", text: "BONJOUR", length: 7, positions: [{ row: 8, col: 8, value: "B" }, { row: 7, col: 7, value: "O" }, { row: 6, col: 6, value: "N" }, { row: 5, col: 5, value: "J" }, { row: 4, col: 4, value: "O" }, { row: 3, col: 3, value: "U" }, { row: 2, col: 2, value: "R" }], reversed: true }
];
